import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42493cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量打印选中选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("批量删除选中项")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

import {
  getWareToolPage,
  deleteWareTool,
  addWareTool,
  editWareTool
} from "@/service/main/gauge/essential";
import Pagination from "@/components/Pagination/index.vue";
import { exportExcel } from "@/utils/exportExcel";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, nextTick } from "vue";
import { formatUtcToData } from "@/utils/formate";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// --------------------工量具列表-----------------------------------
//查询
const formModel = ref({
  Code: "",
  Name: "",
  PageNo: 1,
  PageSize: 10
});

//工量具列表数据
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取工量具列表
const getTabelData = () => {
  getWareToolPage(formModel.value)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        tableData.value = result.rows;
        totalItems.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};
getTabelData();
const printTable = () => {
  console.log(11);
};

//重置搜索
const resetForm = () => {
  formModel.value = {
    Code: "",
    Name: "",
    PageNo: 1,
    PageSize: 10
  };
  getTabelData();
};
// -----------------删除、导出操作--------------------------
//选中的行
const checkRows = ref<any[]>([]);
// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
const tableRef = ref();

//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "工量具编号",
    name: "工量具名称",
    unit: "单位",
    remark: "备注"
  };
  exportExcel(checkRows.value, entozh, "xlsx", "工量具列表");
};
//批量删除
const handleBatchDelete = () => {
  const handleArr: any[] = [];
  checkRows.value.forEach((item) => {
    handleArr.push(item.id);
  });
  const obj = { id: handleArr };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareTool(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
            tableRef.value.clearSelection();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};
//删除
const deleteUser = (id: string) => {
  const obj = { id: [id] };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteWareTool(obj)
        .then((res: any) => {
          if (res?.code === 200) {
            ElMessage.success("删除成功");
            // 刷新列表
            getTabelData();
          } else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`);
          }
        })
        .catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`);
        });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// ----------------新增、编辑-------------------------------
//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//添加/编辑
let addForm = ref({
  createdTime: "",
  updatedTime: "",
  createdUserId: "",
  createdUserName: "",
  specificationModel: "",
  // updatedUserId: "",
  // updatedUserName: "",
  code: "",
  name: "",
  // specificationModel: "",
  remark: "",
  unit: "",
  id: ""
});

//添加编辑表单ref
const orderId = ref(0);

//打开新增、编辑窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = "add";
  } else {
    dialogType.value = "edit";
    addForm.value = Object.assign({}, scope);
  }
  dialogVisible.value = true;
  nextTick(() => {
    dialogRef.value.clearValidate();
  });
};
//rules
const formRules = {
  name: [{ required: true, message: "工量具名称不能为空", trigger: "blur" }],
  code: [{ required: true, message: "工量具编号不能为空", trigger: "blur" }],
  unit: [{ required: true, message: "单位不能为空", trigger: "blur" }]
};
//关闭窗口
const closeDialog = () => {
  addForm.value = {
    createdTime: "",
    updatedTime: "",
    createdUserId: "",
    createdUserName: "",
    specificationModel: "",
    // updatedUserId: "",
    // updatedUserName: "",
    code: "",
    name: "",
    // specificationModel: "",
    remark: "",
    unit: "",
    // status: "",
    id: ""
  };
};
const dialogRef = ref();
//编辑、添加提交
const confirm = () => {
  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      addForm.value.createdUserId = store.state.login.userInfo.id;
      addForm.value.createdUserName = store.state.login.userInfo.name;
      addForm.value.createdTime = formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      );
      addForm.value.updatedTime = formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      );
      if (dialogType.value == "add") {
        addWareTool(addForm.value)
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("创建成功");
              dialogVisible.value = false;
              getTabelData();
            } else {
              ElMessage.error(
                `创建失败${res?.code}:${JSON.stringify(res.message)}`
              );
            }
          })
          .catch((err) => {
            console.log(err);
            ElMessage.error(JSON.stringify(err));
          });
      } else {
        editWareTool(addForm.value)
          .then((res) => {
            if (res.code == 200) {
              ElMessage.success("编辑成功");
              dialogVisible.value = false;
              getTabelData();
            } else {
              ElMessage.error(
                `编辑失败${res?.code}:${JSON.stringify(res.message)}`
              );
            }
          })
          .catch((err) => ElMessage.error(err));
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.Code) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { "label-width": "20px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: printTable
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "row-key": "id",
        ref_key: "tableRef",
        ref: tableRef,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "60",
            align: "center",
            type: "selection",
            "reserve-selection": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具编号",
            width: "240",
            align: "center",
            prop: "code",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            prop: "remark",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-delete",
                onClick: ($event: any) => (deleteUser(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '新增工量具' : '编辑工量具',
      width: "50%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "150px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工量具编号:",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).code,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).code) = $event)),
                          clearable: "",
                          placeholder: "请输入工量具编号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工量具名称:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).name) = $event)),
                          clearable: "",
                          placeholder: "请输入工量具名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工量具规格:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).specificationModel,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).specificationModel) = $event)),
                          clearable: "",
                          placeholder: "请输入工量具规格"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "单位:",
                      prop: "unit"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).unit,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).unit) = $event)),
                          clearable: "",
                          placeholder: "请输入单位"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).remark,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).remark) = $event)),
                          rows: 3,
                          type: "textarea",
                          placeholder: "请输入备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})